'use client'

import PropTypes from 'prop-types'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'
import MUIDivider from '@mui/material/Divider'
import { WizardSidebarTimelineCurrentIcon } from '@repo/ui/WizardSidebarTimelineCurrentIcon'
import { WizardSidebarTimelineDoneIcon } from '@repo/ui/WizardSidebarTimelineDoneIcon'
import { WizardSidebarTimelineNotDoneIcon } from '@repo/ui/WizardSidebarTimelineNotDoneIcon'
import { WizardSidebarTimelineSkippedIcon } from '@repo/ui/WizardSidebarTimelineSkippedIcon'
import { useWizardStore } from '@repo/store/useWizardStore'

const renderIcon = (status, isCurrent) => {
  const sx = {
    width: '18px',
    height: '18px',
    fontSize: '18px',
    position: 'relative',
    zIndex: 2
  }

  if (isCurrent) return <WizardSidebarTimelineCurrentIcon sx={sx} />

  switch (status) {
    case 'completed':
      return <WizardSidebarTimelineDoneIcon sx={sx} />
    case 'skipped':
      return <WizardSidebarTimelineSkippedIcon sx={sx} />
    case 'todo':
    default:
      return <WizardSidebarTimelineNotDoneIcon sx={sx} />
  }
}

const renderLine = (status, isFirst) => {
  if (isFirst) return null

  const sx = {
    borderLeftWidth: '2px',
    borderRightWidth: '0px',
    borderLeftColor: status === 'todo' || !status ? 'lines.slate300' : 'primary.main',
    transition: 'all 300ms',
    height: '50px',
    position: 'absolute',
    zIndex: 1,
    top: '-48px',
    left: '8px'
  }

  return <MUIDivider sx={sx} orientation="vertical" />
}

export const WizardSidebarTimelineItem = ({ step, isFirst, onClick, isCurrent, uniqueId }) => {
  const { wizardState } = useWizardStore()
  const currentStepState = wizardState[uniqueId]

  return (
    <MUIStack
      data-testid="WizardSidebarTimelineItem"
      direction="row"
      gap={'12px'}
      sx={{ mb: '10px', position: 'relative', width: '100%', cursor: 'pointer' }}
      onClick={() => onClick(step.uniqueId)}
    >
      {renderIcon(currentStepState?.status, isCurrent)}

      {renderLine(currentStepState?.status, isFirst)}

      <MUIStack direction="column" sx={{ minHeight: '43px', width: 'calc(100% - 30px)' }}>
        <MUITypography
          variant="body1"
          sx={{
            color: isCurrent ? 'secondary.dark' : 'text.primary',
            mt: '-1px',
            mb: 0,
            pointerEvents: 'none'
          }}
          noWrap
        >
          {step.stepLabel}
        </MUITypography>
        <MUITypography variant="body2" sx={{ color: 'text.secondary', mb: 2, pointerEvents: 'none' }} noWrap>
          {currentStepState?.statusText || ''}
        </MUITypography>
      </MUIStack>
    </MUIStack>
  )
}

WizardSidebarTimelineItem.propTypes = {
  step: PropTypes.object,
  isFirst: PropTypes.bool,
  onClick: PropTypes.func,
  isCurrent: PropTypes.bool,
  uniqueId: PropTypes.string
}
